import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Navbar, Nav, Container, Button, Offcanvas } from 'react-bootstrap';
import { useSession } from '../App';

const MerchantNavigation = ({ currentPage = 'dashboard' }) => {
    const [showMenu, setShowMenu] = useState(false);
    const navigate = useNavigate();
    const { merchant } = useParams();
    const { logout } = useSession();

    const merchantInfo = {
        madeluxe: {
            name: 'Madeluxe',
            color: 'primary'
        },
        pawesome: {
            name: 'Pawesome',
            color: 'success'
        }
    };

    const currentMerchant = merchantInfo[merchant] || {
        name: merchant,
        color: 'secondary'
    };

    const handleCloseMenu = () => setShowMenu(false);

    const handleNavigate = (path) => {
        navigate(path);
        handleCloseMenu();
    };

    const handleLogout = () => {
        // Clear auth tokens
        localStorage.removeItem('authToken');
        localStorage.removeItem('userType');
        localStorage.removeItem('username');

        logout();
        navigate('/index');
    };

    const getPageTitle = () => {
        switch (currentPage) {
            case 'dashboard':
                return 'Dashboard';
            case 'categories':
                return 'Category Management';
            case 'products':
                return 'Product Management';
            default:
                return 'Dashboard';
        }
    };

    return (
        <>
            <Navbar
                bg="light"
                expand="lg"
                className="shadow-sm border-bottom"
                style={{ position: 'sticky', top: 0, zIndex: 1000 }}
            >
                <Container>
                    <Navbar.Brand className="d-flex align-items-center">
                        <Button
                            variant="outline-secondary"
                            size="sm"
                            className="me-3"
                            onClick={() => setShowMenu(true)}
                        >
                            ☰
                        </Button>
                        <div>
                            <span className="fw-bold text-primary">{currentMerchant.name}</span>
                            <span className="text-muted ms-2">- {getPageTitle()}</span>
                        </div>
                    </Navbar.Brand>


                </Container>
            </Navbar>

            <Offcanvas
                show={showMenu}
                onHide={handleCloseMenu}
                placement="start"
                className="merchant-sidebar"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>
                        <span className="fw-bold text-primary">{currentMerchant.name}</span>
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body className="p-0">
                    <Nav className="flex-column">
                        <Nav.Link
                            className="py-3 px-4 border-bottom"
                            onClick={() => navigate('/private/index')}
                        >
                            <div className="d-flex align-items-center">
                                <span className="me-3">🏛️</span>
                                <span>Main Page</span>
                            </div>
                        </Nav.Link>

                        <Nav.Link
                            className={`py-3 px-4 border-bottom ${currentPage === 'dashboard' ? 'active bg-primary text-white' : ''}`}
                            onClick={() => handleNavigate(`/private/${merchant}`)}
                        >
                            <div className="d-flex align-items-center">
                                <span className="me-3">🏠</span>
                                <span>Dashboard</span>
                            </div>
                        </Nav.Link>

                        <Nav.Link
                            className={`py-3 px-4 border-bottom ${currentPage === 'categories' ? 'active bg-primary text-white' : ''}`}
                            onClick={() => handleNavigate(`/private/${merchant}/categories`)}
                        >
                            <div className="d-flex align-items-center">
                                <span className="me-3">📂</span>
                                <span>Categories</span>
                            </div>
                        </Nav.Link>

                        <Nav.Link
                            className={`py-3 px-4 border-bottom ${currentPage === 'products' ? 'active bg-primary text-white' : ''}`}
                            onClick={() => handleNavigate(`/private/${merchant}/products`)}
                        >
                            <div className="d-flex align-items-center">
                                <span className="me-3">📦</span>
                                <span>Products</span>
                            </div>
                        </Nav.Link>

                        <div className="mt-auto p-3">
                            <Button
                                variant="outline-danger"
                                className="w-100"
                                onClick={handleLogout}
                            >
                                <span className="me-2">🚪</span>
                                Logout
                            </Button>
                        </div>
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default MerchantNavigation;
